import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button as MuiButton, Typography, Container } from '@mui/material';
import barcode from '../assets/images/bicycle_game/barcode-aztec-crem.png';

// Stil pentru containerul paginii - acum este full width
const PageWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh', 
  width: '100%',
  backgroundColor: '#4a3824',
  padding: '2rem 0',
  boxSizing: 'border-box'
});

const ContentBox = styled(Box)({
  backgroundColor: '#4a3824',
  padding: '2rem',
  borderRadius: '4px',
  border: '2px dotted #e9d4a8',
  width: '100%',
  maxWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '0 1rem'
});

const ActionButton = styled(MuiButton)({
  backgroundColor: '#f5e8c9',
  color: '#4a3824',
  fontWeight: 'bold',
  padding: '10px 20px',
  fontSize: '1.2rem',
  '&:hover': {
    backgroundColor: '#ffffff',
  },
  borderRadius: '4px',
  boxShadow: 'none',
  textTransform: 'uppercase'
});

const KauflandQr: React.FC = () => {

  const handleDownloadPdf = () => {
    const pdfUrl = `/pdf/qr kauf.pdf`;
    
    // Create an anchor element and set properties for download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Kozel_Kaufland_Voucher.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  React.useEffect(() => {
    const originalBodyStyle = document.body.style.cssText;
    const originalHtmlStyle = document.documentElement.style.cssText;
    
    document.body.style.backgroundColor = '#4a3824';
    document.body.style.margin = '0';
    document.documentElement.style.backgroundColor = '#4a3824';
    
    return () => {
      document.body.style.cssText = originalBodyStyle;
      document.documentElement.style.cssText = originalHtmlStyle;
    };
  }, []);

  return (
    <PageWrapper>
      <ContentBox>
        <Typography variant="h4" sx={{ 
          fontWeight: 'bold', 
          textAlign: 'center', 
          color: '#e9d4a8',
          mb: 2
        }}>
          Împreună facem echipă tzaaapănă!
        </Typography>
        
        <Typography variant="h4" sx={{ 
          textAlign: 'center', 
          fontWeight: 'bold',
          color: '#fff',
          mb: 1,
          textTransform: 'uppercase'
        }}>
          voucher 20% discount
        </Typography>

        <Typography variant="h6" sx={{ 
          textAlign: 'center', 
          fontWeight: 'bold',
          color: '#e9d4a8',
          mb: 3,
          textTransform: 'uppercase'
        }}>
          la Kozel, în Kaufland
          <span role="img" aria-label="sunglasses"> 😎</span>
        </Typography>

        {/* QR Code */}
        <Box
          component="img"
          src={barcode}
          alt="Barcode voucher"
          sx={{
            maxWidth: '300px',
            width: '100%',
            height: 'auto',
            margin: '0 auto',
            display: 'block'
          }}
        />

        <Typography sx={{ 
            textAlign: 'center', 
            color: '#e9d4a8',
            fontSize: '14px',
            fontStyle: 'italic',
            mt: 3
          }}>
            Scanează voucherul la casa de marcat Kaufland, separat pentru fiecare produs Kozel cumpărat!<br />
            Toate produsele Kozel achizițonate beneficiază de reducere.
        </Typography>
        
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <ActionButton
            sx={{
              backgroundColor: '#f5e8c9',
              mb: 2
            }}
            onClick={handleDownloadPdf}
          >
            Descarcă PDF
          </ActionButton>
          
          <Typography sx={{ 
            textAlign: 'center', 
            color: '#e9d4a8',
            fontSize: '14px',
            fontStyle: 'italic',
            mt: 1
          }}>
            Sau fă o captură codului și folosește-l la<br />
            orice magazin Kaufland din țară!
          </Typography>
        </Box>
      </ContentBox>
    </PageWrapper>
  );
};

export default KauflandQr;